module.exports = __webpack_public_path__ + "dfc972361cf2bcf553ac13af5da6af2a.png";